export const MATCH_TYPE_OPTIONS = [
    { label: "Exact", value: "EXACT" },
    { label: "Phrase", value: "PHRASE" },
    { label: "Broad", value: "BROAD" },
]

export const KEYWORD_TYPE_OPTIONS = [
    { label: "Keyword", value: "positive" },
    { label: "Negative Keyword", value: "negative" },
]